import { request } from "@/api/server/index";

export default {
  //V051_ユーザマスタ
  UserMaster: {
    //初期表示
    indexUserMaster(params) {
      return request({
        url: "/userMaster/indexUserMaster",
        data: params,
        method: "post"
      });
    },
    //V051-1初期表示
    indexUserMasterEdit(params) {
      return request({
        url: "/userMaster/indexUserMasterEdit",
        data: params,
        method: "post"
      });
    },
    //部署のリストを更新します
    searchDepartmentList(params) {
      return request({
        url: "/userMaster/searchDepartmentList",
        data: params,
        method: "post"
      });
    },
    //削除（b4）をクリックしたときの処理
    deleteUserMaster(params) {
      return request({
        url: "/userMaster/deleteUserMaster",
        data: params,
        method: "post"
      });
    },
    //登録(新規登録)
    insertUserMaster(params) {
      return request({
        url: "/userMaster/insertUserMaster",
        data: params,
        method: "post"
      });
    },
    //登録(編集)
    updateUserMaster(params) {
      return request({
        url: "/userMaster/updateUserMaster",
        data: params,
        method: "post"
      });
    }
  },
  //V052_出先・部署マスタ画面
  BranchMaster: {
    //（V052）の初期表示
    indexBranchMaster(params) {
      return request({
        url: "/branchMaster/indexBranchMaster",
        data: params,
        method: "post"
      });
    },
    //（V052-1）の初期表示
    indexBranchMasterEdit(params) {
      return request({
        url: "/branchMaster/indexBranchMasterEdit",
        data: params,
        method: "post"
      });
    },
    //削除（b6）をクリックしたときの処理
    deleteBranchMaster(params) {
      return request({
        url: "/branchMaster/deleteBranchMaster",
        data: params,
        method: "post"
      });
    },
    //出先マスタ新規登録
    insertBranchMaster(params) {
      return request({
        url: "/branchMaster/insertBranchMaster",
        data: params,
        method: "post"
      });
    },
    //出先マスタ編集
    updateBranchMaster(params) {
      return request({
        url: "/branchMaster/updateBranchMaster",
        data: params,
        method: "post"
      });
    },
    //（V052-2）の初期表示
    indexDepartmentMasterEdit(params) {
      return request({
        url: "/branchMaster/indexDepartmentMasterEdit",
        data: params,
        method: "post"
      });
    },
    //削除（b9）をクリックしたときの処理
    deleteDepartmentMaster(params) {
      return request({
        url: "/branchMaster/deleteDepartmentMaster",
        data: params,
        method: "post"
      });
    },
    //部署マスタ新規登録
    insertDepartmentMaster(params) {
      return request({
        url: "/branchMaster/insertDepartmentMaster",
        data: params,
        method: "post"
      });
    },
    //部署マスタ編集
    updateDepartmentMaster(params) {
      return request({
        url: "/branchMaster/updateDepartmentMaster",
        data: params,
        method: "post"
      });
    }
  },
  //V053_担当者別目標マスタ画面
  UserPerformanceGoal: {
    //初期表示
    indexUserPerformanceGoal(params) {
      return request({
        url: "/userPerformanceGoal/indexUserPerformanceGoal",
        data: params,
        method: "post"
      });
    },
    //部署マスタリスト取得
    searchDepartmentList(params) {
      return request({
        url: "/userPerformanceGoal/searchDepartmentList",
        data: params,
        method: "post"
      });
    },
    //検索(b6)ボタンをクリックしたときの処理
    searchUserPerformanceGoalList(params) {
      return request({
        url: "/userPerformanceGoal/searchUserPerformanceGoalList",
        data: params,
        method: "post"
      });
    },
    //登録
    insertOrUpdateUserPerformanceGoal(params) {
      return request({
        url: "/userPerformanceGoal/insertOrUpdateUserPerformanceGoal",
        data: params,
        method: "post"
      });
    }
  },
  //V055_顧客分類マスタ画面
  CustomerKindMaster: {
    //初期表示
    indexCustomerKind(params) {
      return request({
        url: "/customerKind/indexCustomerKind",
        data: params,
        method: "post"
      });
    },
    // 顧客分類登録 顧客分類削除
    deleteCustomerKind(params) {
      return request({
        url: "/customerKind/deleteCustomerKind",
        data: params,
        method: "post"
      });
    },
    //顧客分類登録（新規登録）
    insertCustomerKind(params) {
      return request({
        url: "/customerKind/insertCustomerKind",
        data: params,
        method: "post"
      });
    },
    //顧客分類登録 初期表示
    indexCustomerKindEdit(params) {
      return request({
        url: "/customerKind/indexCustomerKindEdit",
        data: params,
        method: "post"
      });
    },
    //顧客分類登録（編集）
    updateCustomerKind(params) {
      return request({
        url: "/customerKind/updateCustomerKind",
        data: params,
        method: "post"
      });
    }
  },
  //V056_団体分類マスタ画面
  OrgKindMaster: {
    //団体分類マスタ画面 初期表示
    indexOrgKind(params) {
      return request({
        url: "/orgKind/indexOrgKind",
        data: params,
        method: "post"
      });
    },
    //団体分類登録 初期表示
    indexOrgKindEdit(params) {
      return request({
        url: "/orgKind/indexOrgKindEdit",
        data: params,
        method: "post"
      });
    },
    // 登録(新規登録)
    insertOrgKind(params) {
      return request({
        url: "/orgKind/insertOrgKind",
        data: params,
        method: "post"
      });
    },
    //登録(編集)
    updateOrgKind(params) {
      return request({
        url: "/orgKind/updateOrgKind",
        data: params,
        method: "post"
      });
    },
    // 削除
    deleteOrgKind(params) {
      return request({
        url: "/orgKind/deleteOrgKind",
        data: params,
        method: "post"
      });
    }
  },
  //V057_保険会社マスタ画面
  InsuranceCorpMaster: {
    //初期表示
    indexInsuranceCorpMaster(params) {
      return request({
        url: "/insuranceCorpMaster/indexInsuranceCorpMaster",
        data: params,
        method: "post"
      });
    },
    //登録
    insertInsuranceCorpMaster(params) {
      return request({
        url: "/insuranceCorpMaster/insertInsuranceCorpMaster",
        data: params,
        method: "post"
      });
    }
  },
  //V058_保険商品マスタ画面
  ProductMaster: {
    //初期表示
    indexProductMaster(params) {
      return request({
        url: "/productMaster/indexProductMaster",
        data: params,
        method: "post"
      });
    },
    //検索
    searchProductMaster(params) {
      return request({
        url: "/productMaster/searchProductMaster",
        data: params,
        method: "post"
      });
    },
    //編集画面初期表示
    indexProductMasterEdit(params) {
      return request({
        url: "/productMaster/indexProductMasterEdit",
        data: params,
        method: "post"
      });
    },
    //削除
    deleteProductMaster(params) {
      return request({
        url: "/productMaster/deleteProductMaster",
        data: params,
        method: "post"
      });
    },
    //登録(新規登録)
    insertProductMaster(params) {
      return request({
        url: "/productMaster/insertProductMaster",
        data: params,
        method: "post"
      });
    },
    //登録(編集)
    updateProductMaster(params) {
      return request({
        url: "/productMaster/updateProductMaster",
        data: params,
        method: "post"
      });
    }
  },
  //V059_受付経路マスタ画面
  PathMaster: {
    //初期表示
    indexPath(params) {
      return request({
        url: "/path/indexPath",
        data: params,
        method: "post"
      });
    },
    //削除
    deletePath(params) {
      return request({
        url: "/path/deletePath",
        data: params,
        method: "post"
      });
    },
    //登録(新規登録)
    insertPath(params) {
      return request({
        url: "/path/insertPath",
        data: params,
        method: "post"
      });
    },
    // 登録(編集)
    updatePath(params) {
      return request({
        url: "/path/updatePath",
        data: params,
        method: "post"
      });
    },
    // 登録画面(V059-1)の初期表示
    indexPathEdit(params) {
      return request({
        url: "/path/indexPathEdit",
        data: params,
        method: "post"
      });
    }
  },
  //V060_対応種別マスタ画面
  ContactKindMaster: {
    //初期表示
    indexContactKind(params) {
      return request({
        url: "/contactKind/indexContactKind",
        data: params,
        method: "post"
      });
    },
    // 削除
    deleteContactKind(params) {
      return request({
        url: "/contactKind/deleteContactKind",
        data: params,
        method: "post"
      });
    },
    //登録(新規登録)
    insertContactKind(params) {
      return request({
        url: "/contactKind/insertContactKind",
        data: params,
        method: "post"
      });
    },
    //登録(編集)
    updateContactKind(params) {
      return request({
        url: "/contactKind/updateContactKind",
        data: params,
        method: "post"
      });
    },
    //登録画面(V060-1)の初期表示
    indexContactKindEdit(params) {
      return request({
        url: "/contactKind/indexContactKindEdit",
        data: params,
        method: "post"
      });
    }
  },
  //V061_対応履歴定型文マスタ画面
  ContactSampleMaster: {
    //初期表示
    indexContactSample(params) {
      return request({
        url: "/contactSample/indexContactSample",
        data: params,
        method: "post"
      });
    },
    //削除
    deleteContactSample(params) {
      return request({
        url: "/contactSample/deleteContactSample",
        data: params,
        method: "post"
      });
    },
    //登録(新規登録)
    insertContactSample(params) {
      return request({
        url: "/contactSample/insertContactSample",
        data: params,
        method: "post"
      });
    },
    //登録(編集)
    updateContactSample(params) {
      return request({
        url: "/contactSample/updateContactSample",
        data: params,
        method: "post"
      });
    },
    //V061-1初期表示
    indexContactSampleEdit(params) {
      return request({
        url: "/contactSample/indexContactSampleEdit",
        data: params,
        method: "post"
      });
    }
  },
  //V062_添付種類マスタ画面
  AttachmentKindMaster: {
    //V062_添付種類マスタ画面 初期表示
    indexAttachmentKind(params) {
      return request({
        url: "/attachmentKind/indexAttachmentKind",
        data: params,
        method: "post"
      });
    },
    //V062_添付種類登録画面  初期表示
    indexAttachmentKindEdit(params) {
      return request({
        url: "/attachmentKind/indexAttachmentKindEdit",
        data: params,
        method: "post"
      });
    },
    //V062_添付種類登録画面  削除
    deleteAttachmentKind(params) {
      return request({
        url: "/attachmentKind/deleteAttachmentKind",
        data: params,
        method: "post"
      });
    },
    //V062_添付種類登録画面 新規登録
    insertAttachmentKind(params) {
      return request({
        url: "/attachmentKind/insertAttachmentKind",
        data: params,
        method: "post"
      });
    },
    //V062_添付種類登録画面 編集
    updateAttachmentKind(params) {
      return request({
        url: "/attachmentKind/updateAttachmentKind",
        data: params,
        method: "post"
      });
    }
  },
  //V063_個人データ種類マスタ画面
  PersonalInfoKindMaster: {
    //V063_個人データ種類マスタ画面 初期表示
    indexPersonalInfoKind(params) {
      return request({
        url: "/personalInfoKind/indexPersonalInfoKind",
        data: params,
        method: "post"
      });
    },
    //V063_個人データ種類登録 初期表示
    indexPersonalInfoKindEdit(params) {
      return request({
        url: "/personalInfoKind/indexPersonalInfoKindEdit",
        data: params,
        method: "post"
      });
    },
    //V063_個人データ種類登録 削除
    deletePersonalInfoKind(params) {
      return request({
        url: "/personalInfoKind/deletePersonalInfoKind",
        data: params,
        method: "post"
      });
    },
    //V063_個人データ種類登録 新規登録
    insertPersonalInfoKind(params) {
      return request({
        url: "/personalInfoKind/insertPersonalInfoKind",
        data: params,
        method: "post"
      });
    },
    //V063_個人データ種類登録 編集
    updatePersonalInfoKind(params) {
      return request({
        url: "/personalInfoKind/updatePersonalInfoKind",
        data: params,
        method: "post"
      });
    }
  },
  //V064_ご希望の保障分野マスタ画面
  IntentHearingItemMaster: {
    //初期表示
    indexIntentHearingItem(params) {
      return request({
        url: "/intentHearingItem/indexIntentHearingItem",
        data: params,
        method: "post"
      });
    },
    //編集画面初期表示
    indexIntentHearingItemEdit(params) {
      return request({
        url: "/intentHearingItem/indexIntentHearingItemEdit",
        data: params,
        method: "post"
      });
    },
    //削除
    deleteIntentHearingItem(params) {
      return request({
        url: "/intentHearingItem/deleteIntentHearingItem",
        data: params,
        method: "post"
      });
    },
    //登録(新規登録)
    insertIntentHearingItem(params) {
      return request({
        url: "/intentHearingItem/insertIntentHearingItem",
        data: params,
        method: "post"
      });
    },
    //登録(編集)
    updateIntentHearingItem(params) {
      return request({
        url: "/intentHearingItem/updateIntentHearingItem",
        data: params,
        method: "post"
      });
    }
  },
  //V065_お客様のご意向マスタ画面
  RecommendationReasonMaster: {
    // 初期表示
    indexRecommendationReason(params) {
      return request({
        url: "/recommendationReason/indexRecommendationReason",
        data: params,
        method: "post"
      });
    },
    //登録(新規登録)
    insertRecommendationReason(params) {
      return request({
        url: "/recommendationReason/insertRecommendationReason",
        data: params,
        method: "post"
      });
    },
    //登録(編集)
    updateRecommendationReason(params) {
      return request({
        url: "/recommendationReason/updateRecommendationReason",
        data: params,
        method: "post"
      });
    },
    // 削除
    deleteRecommendationReason(params) {
      return request({
        url: "/recommendationReason/deleteRecommendationReason",
        data: params,
        method: "post"
      });
    },
    //編集画面初期表示
    indexRecommendationReasonEdit(params) {
      return request({
        url: "/recommendationReason/indexRecommendationReasonEdit",
        data: params,
        method: "post"
      });
    }
  },
  //V066_ご意向の振り返りマスタ画面
  IntentConfirmItemMaster: {
    // 初期表示
    indexIntentConfirmItem(params) {
      return request({
        url: "/intentConfirmItem/indexIntentConfirmItem",
        data: params,
        method: "post"
      });
    },
    // 登録(新規登録)
    insertIntentConfirmItem(params) {
      return request({
        url: "/intentConfirmItem/insertIntentConfirmItem",
        data: params,
        method: "post"
      });
    },
    // 登録(編集)
    updateIntentConfirmItem(params) {
      return request({
        url: "/intentConfirmItem/updateIntentConfirmItem",
        data: params,
        method: "post"
      });
    },
    // 削除
    deleteIntentConfirmItem(params) {
      return request({
        url: "/intentConfirmItem/deleteIntentConfirmItem",
        data: params,
        method: "post"
      });
    },
    // 編集画面初期表示
    indexIntentConfirmItemEdit(params) {
      return request({
        url: "/intentConfirmItem/indexIntentConfirmItemEdit",
        data: params,
        method: "post"
      });
    }
  },
  //V067_案件アクション設計画面
  ProcessDesign: {
    // 初期表示
    indexProcessDesign(params) {
      return request({
        url: "/processDesign/indexProcessDesign",
        data: params,
        method: "post"
      });
    },
    // 新規案件(V067-1)の初期表示
    indexNewProcessDesignEdit(params) {
      return request({
        url: "/processDesign/indexNewProcessDesignEdit",
        data: params,
        method: "post"
      });
    },
    // 新規案件複製
    copyNewProcessDesignEdit(params) {
      return request({
        url: "/processDesign/copyNewProcessDesignEdit",
        data: params,
        method: "post"
      });
    },
    // 新規案件登録(新規登録)
    insertNewProcessDesignEdit(params) {
      return request({
        url: "/processDesign/insertNewProcessDesignEdit",
        data: params,
        method: "post"
      });
    },
    // 新規・保全案件削除
    deleteProcessDesignEdit(params) {
      return request({
        url: "/processDesign/deleteProcessDesignEdit",
        data: params,
        method: "post"
      });
    },
    // 新規案件登録(編集)
    updateNewProcessDesignEdit(params) {
      return request({
        url: "/processDesign/updateNewProcessDesignEdit",
        data: params,
        method: "post"
      });
    },
    // 保全案件(V067-2)初期表示
    indexOldProcessDesignEdit(params) {
      return request({
        url: "/processDesign/indexOldProcessDesignEdit",
        data: params,
        method: "post"
      });
    },
    // 保全案件複製
    copyOldProcessDesignEdit(params) {
      return request({
        url: "/processDesign/copyOldProcessDesignEdit",
        data: params,
        method: "post"
      });
    },
    // 保全案件登録(新規登録)
    insertOldProcessDesignEdit(params) {
      return request({
        url: "/processDesign/insertOldProcessDesignEdit",
        data: params,
        method: "post"
      });
    },
    // 保全案件登録(編集)
    updateOldProcessDesignEdit(params) {
      return request({
        url: "/processDesign/updateOldProcessDesignEdit",
        data: params,
        method: "post"
      });
    },
    // 損保満期更改の初期表示
    indexDueProcessDesignEdit(params) {
      return request({
        url: "/processDesign/indexDueProcessDesignEdit",
        data: params,
        method: "post"
      });
    },
    // 登録（損保満期更改）
    insertDueProcessDesignEdit(params) {
      return request({
        url: "/processDesign/insertDueProcessDesignEdit",
        data: params,
        method: "post"
      });
    },
    // 編集（損保満期更改）
    updateDueProcessDesignEdit(params) {
      return request({
        url: "/processDesign/updateDueProcessDesignEdit",
        data: params,
        method: "post"
      });
    },
    // 編集（損保満期更改）
    copyDueProcessDesignEdit(params) {
      return request({
        url: "/processDesign/copyDueProcessDesignEdit",
        data: params,
        method: "post"
      });
    }
  },
  //V084_保険特約マスタ画面
  SpecialContractMaster: {
    //初期表示
    indexSpecialContract(params) {
      return request({
        url: "/specialContract/indexSpecialContract",
        data: params,
        method: "post"
      });
    },
    // 保険会社（i1）の値を変更
    insuranceCorpCdChange(params) {
      return request({
        url: "/specialContract/insuranceCorpCdChange",
        data: params,
        method: "post"
      });
    },
    //カテゴリ（i2）の値を変更
    categoryCdChange(params) {
      return request({
        url: "/specialContract/categoryCdChange",
        data: params,
        method: "post"
      });
    },
    //商品特約リンク登録画面（V084-1）の初期表示
    indexProductSpecialContractEdit(params) {
      return request({
        url: "/specialContract/indexProductSpecialContractEdit",
        data: params,
        method: "post"
      });
    },
    //商品リンクを登録する
    insertProductSpecialContractEdit(params) {
      return request({
        url: "/specialContract/insertProductSpecialContractEdit",
        data: params,
        method: "post"
      });
    },
    //特約登録画面（V084-2）の初期表示
    indexSpecialContractEdit(params) {
      return request({
        url: "/specialContract/indexSpecialContractEdit",
        data: params,
        method: "post"
      });
    },
    // 削除（特約登録）（b7）
    deleteSpecialContractEdit(params) {
      return request({
        url: "/specialContract/deleteSpecialContractEdit",
        data: params,
        method: "post"
      });
    },
    // 登録（特約登録）（b8）
    insertSpecialContractEdit(params) {
      return request({
        url: "/specialContract/insertSpecialContractEdit",
        data: params,
        method: "post"
      });
    }
  },
  //V085_募集企画対象者区分マスタ画面
  CampaignCustomerCategory: {
    //初期表示
    indexCampaignCustomerCategory(params) {
      return request({
        url: "/campaignCustomerCategory/indexCampaignCustomerCategory",
        data: params,
        method: "post"
      });
    },
    //募集企画対象者区分登録画面(V085-1)初期表示
    indexCampaignCustomerCategoryEdit(params) {
      return request({
        url: "/campaignCustomerCategory/indexCampaignCustomerCategoryEdit",
        data: params,
        method: "post"
      });
    },
    //削除
    deleteCampaignCustomerCategory(params) {
      return request({
        url: "/campaignCustomerCategory/deleteCampaignCustomerCategory",
        data: params,
        method: "post"
      });
    },
    //新規登録
    insertCampaignCustomerCategory(params) {
      return request({
        url: "/campaignCustomerCategory/insertCampaignCustomerCategory",
        data: params,
        method: "post"
      });
    },
    //編集
    updateCampaignCustomerCategory(params) {
      return request({
        url: "/campaignCustomerCategory/updateCampaignCustomerCategory",
        data: params,
        method: "post"
      });
    }
  },
  //V087_送付書類マスタ画面
  Letter: {
    //初期表示
    indexLetter(params) {
      return request({
        url: "/letter/indexLetter",
        data: params,
        method: "post"
      });
    },
    //送付書類登録画面(V087-1)初期表示
    indexLetterEdit(params) {
      return request({
        url: "/letter/indexLetterEdit",
        data: params,
        method: "post"
      });
    },
    //削除
    deleteLetter(params) {
      return request({
        url: "/letter/deleteLetter",
        data: params,
        method: "post"
      });
    },
    //新規登録
    insertLetter(params) {
      return request({
        url: "/letter/insertLetter",
        data: params,
        method: "post"
      });
    },
    //編集
    updateLetter(params) {
      return request({
        url: "/letter/updateLetter",
        data: params,
        method: "post"
      });
    }
  },
  //V088_送付状挨拶文マスタ画面
  Greeting: {
    //初期表示
    indexGreeting(params) {
      return request({
        url: "/greeting/indexGreeting",
        data: params,
        method: "post"
      });
    },
    //挨拶文登録画面(V088-1)初期表示
    indexGreetingEdit(params) {
      return request({
        url: "/greeting/indexGreetingEdit",
        data: params,
        method: "post"
      });
    },
    //削除
    deleteGreeting(params) {
      return request({
        url: "/greeting/deleteGreeting",
        data: params,
        method: "post"
      });
    },
    //新規登録
    insertGreeting(params) {
      return request({
        url: "/greeting/insertGreeting",
        data: params,
        method: "post"
      });
    },
    //編集
    updateGreeting(params) {
      return request({
        url: "/greeting/updateGreeting",
        data: params,
        method: "post"
      });
    }
  },
  SuitabilityItem: {
    //初期表示
    indexSuitabilityItem(params) {
      return request({
        url: "/suitabilityItem/indexSuitabilityItem",
        data: params,
        method: "post"
      });
    },
    //適合性確認項目登録ダイアログ(V092-1)を開いた時の処理
    indexSuitabilityItemEdit(params) {
      return request({
        url: "/suitabilityItem/indexSuitabilityItemEdit",
        data: params,
        method: "post"
      });
    },
    //適合性確認項目登録ダイアログ(V092-1)の登録（項目）(b7)をクリックしたときの処理(新規登録モード)
    insertSuitabilityItem(params) {
      return request({
        url: "/suitabilityItem/insertSuitabilityItem",
        data: params,
        method: "post"
      });
    },
    //適合性確認項目登録ダイアログ(V092-1)の登録（項目）(b7)をクリックしたときの処理(編集モード)
    updateSuitabilityItem(params) {
      return request({
        url: "/suitabilityItem/updateSuitabilityItem",
        data: params,
        method: "post"
      });
    },
    //適合性確認項目登録ダイアログ(V092-1)の削除（項目）(b6)をクリックしたときの処理
    deleteSuitabilityItem(params) {
      return request({
        url: "/suitabilityItem/deleteSuitabilityItem",
        data: params,
        method: "post"
      });
    },
    //適合性確認項目登録ダイアログ(V092-1)の新規登録（サブ項目）(b4)をクリックしたときの処理
    indexInsertSuitabilitySubItemEdit(params) {
      return request({
        url: "/suitabilityItem/indexInsertSuitabilitySubItemEdit",
        data: params,
        method: "post"
      });
    },
    //適合性確認項目サブ登録ダイアログ(V092-2)を開いた時の処理
    indexUpdateSuitabilitySubItemEdit(params) {
      return request({
        url: "/suitabilityItem/indexUpdateSuitabilitySubItemEdit",
        data: params,
        method: "post"
      });
    },
    //適合性確認項目登録ダイアログ(V092-2)の登録（サブ項目）(b10)をクリックしたときの処理(新規登録モード)
    insertSuitabilitySubItem(params) {
      return request({
        url: "/suitabilityItem/insertSuitabilitySubItem",
        data: params,
        method: "post"
      });
    },
    //適合性確認項目登録ダイアログ(V092-2)の登録（サブ項目）(b10)をクリックしたときの処理(編集モード)
    updateSuitabilitySubItem(params) {
      return request({
        url: "/suitabilityItem/updateSuitabilitySubItem",
        data: params,
        method: "post"
      });
    },
    //適合性確認項目サブ登録ダイアログ(V092-2)の削除（サブ項目）(b9)をクリックしたときの処理
    deleteSuitabilitySubItem(params) {
      return request({
        url: "/suitabilityItem/deleteSuitabilitySubItem",
        data: params,
        method: "post"
      });
    }
  }
};
